import { isEmpty } from '../../utils/fp';
import C from './constants';

const parseLabelAndId = str => {
  if (!str) return [null, null];
  const parts = str.split('#').filter(p => p !== '');
  return [parts[0] || null, parts[1] || null];
};

const isFullyHighlighted = str => {
  if (!str) return false;
  const trimmed = str.trim();
  return /^<mark>[\s\S]*<\/mark>$/.test(trimmed);
};

const hasMarkTag = str => /<(\/)?mark>/.test(str);

const switchHighlight = str => {
  const [label, id] = parseLabelAndId(str);
  if (isFullyHighlighted(id)) {
    if (hasMarkTag(label)) return `${label}#${id}#`;
    return `<mark>${label}</mark>#${id}#`;
  }
  return str;
};

const parseId = hl => {
  const m = hl.match(C.VALUE_MASK) || [];
  if (!isEmpty(m)) return m[1].replace(/<\/?mark>/g, '');
  const fallback = hl.match(/<mark>(.*?)<\/mark>/) || [];
  if (!isEmpty(fallback)) return fallback[1];
  return null;
};

export default hl => {
  if (!hasMarkTag(hl)) return null;

  const split = hl.split(C.FACET_LEVEL_SEPARATOR);

  const highlighted = split.map(switchHighlight);
  const trimmed = highlighted.length > 1 ? highlighted.slice(1) : highlighted;

  return {
    valueId: parseId(split.at(-1)),
    label: trimmed.join(C.FACET_HIGHLIGHT_SEPARATOR).replace(C.FACET_VALUE_MASK, ''),
  };
};
